// @ts-ignore
import type * as SchemaTypes from '../../index';

import { gql } from 'graphql-tag';
import { EnquiryResponseNewCustomerFragmentDoc } from '../../../../components/enquiry/api/enquiryResponseNewCustomer.fragment.generated';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateDiamondSearchProductEnquiryNewCustomerDocument = gql`
    mutation createDiamondSearchProductEnquiryNewCustomer($input: EnquiryDiamondSearchProduct!, $customer: CustomerRegistrationInput!, $locale: Locale!, $isConsultant: Boolean!) {
  createEnquiryDiamondSearchProductNewCustomer(input: $input, customer: $customer) {
    ...enquiryResponseNewCustomer
  }
}
    ${EnquiryResponseNewCustomerFragmentDoc}`;

export function useCreateDiamondSearchProductEnquiryNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateDiamondSearchProductEnquiryNewCustomerMutation, SchemaTypes.CreateDiamondSearchProductEnquiryNewCustomerMutationVariables>(CreateDiamondSearchProductEnquiryNewCustomerDocument);
};